import React, { useState, useEffect } from 'react';

const UpdateResumeModal = ({ isOpen, onClose, onSave, currentName }) => {
    const [resumeName, setResumeName] = useState('');

    useEffect(() => {
        if (isOpen) {
            setResumeName(currentName);
        }
    }, [isOpen, currentName]);

    if (!isOpen) return null;

    const handleSave = (e) => {
        e.preventDefault();
        if (!resumeName) {
            alert('Resume name cannot be empty.');
            return;
        }
        onSave(resumeName);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4">
            <div className="relative w-full max-w-lg rounded-2xl border border-white/10 bg-[#0b0e14] p-8 text-white shadow-2xl">
                <button onClick={onClose} className="absolute top-4 right-4 text-neutral-400 hover:text-white text-2xl font-bold">&times;</button>
                <h1 className="text-2xl font-bold text-center mb-8">Update your resume</h1>
                <form onSubmit={handleSave} className="space-y-6">
                    <div>
                        <label htmlFor="resumeNameUpdate" className="block text-xs font-bold text-neutral-400 uppercase mb-2">
                            RESUME NAME <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            id="resumeNameUpdate"
                            value={resumeName}
                            onChange={(e) => setResumeName(e.target.value)}
                            className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder-neutral-500 focus:outline-none focus:ring-2 focus:ring-cyan-500/60 focus:border-transparent"
                            required
                        />
                    </div>
                    <div>
                        <label htmlFor="experienceUpdate" className="block text-xs font-bold text-neutral-400 uppercase mb-2">EXPERIENCE</label>
                        <select id="experienceUpdate" defaultValue="Entry level" className="w-full bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-sm text-white appearance-none focus:outline-none focus:ring-2 focus:ring-cyan-500/60 focus:border-transparent">
                            <option>Entry level</option>
                            <option>Mid Level</option>
                            <option>Senior Level</option>
                        </select>
                    </div>

                    <div className="flex justify-end space-x-4 pt-4">
                        <button type="button" onClick={onClose} className="text-neutral-400 hover:text-white font-semibold py-2 px-6">
                            CANCEL
                        </button>
                        <button type="submit" className="bg-cyan-500 hover:bg-cyan-400 text-black font-semibold py-2 px-6 rounded-lg transition-colors shadow-lg shadow-cyan-500/10">
                            SAVE
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateResumeModal;